import _ from 'lodash';
import page from 'page';
import * as pathToRegexp from 'path-to-regexp';

import { queryString } from '..';
import { toUrlParams } from '../url/url';

const compiledPaths = {};

export const location = {
  getCurrentLocation() {
    return window.location;
  },

  getCurrentPathname() {
    return this.getCurrentLocation().pathname;
  },

  getQueryParameters(): any {
    const search = this.getCurrentLocation().search;
    return queryString.parse(search);
  },
};

/**
 * Register page's popstate
 */
export const start = () => page.start({ click: false });

/**
 * Unbind the popstate handlers
 */
export const stop = () => page.stop();

/**
 * If method was called with one argument - waits for the current route to push state and after replaces it
 * with the new one leaving the browser history clean otherwise registers redirect.
 * @param  {String} from
 * @param  {String?} to
 */
export const redirect = (from: string, to?: string) =>
  to ? page.redirect(from, to) : page.redirect(from);

/**
 * Transforming an express path into valid path
 *
 * compilePath('/user/:id', { id: 123 }, { path: 'hello' }) //=> "/user/123?path=hello"
 *
 * @param  {String} path
 * @param  {Object} params
 * @param  {Object?} queryParams
 * @return {String}
 */
export const compilePath = (path, params, queryParams?: {}) => {
  let buildURL: (data?: object) => string;

  let origin = '';
  let pathname = path;
  if (path.startsWith('https://') || path.startsWith('http://')) {
    ({ origin, pathname } = new URL(path));
  }
  if (compiledPaths[pathname]) {
    buildURL = compiledPaths[pathname];
  } else {
    buildURL = pathToRegexp.compile(pathname);
    compiledPaths[pathname] = buildURL;
  }
  const urlParams = toUrlParams(queryParams);

  return `${origin}${buildURL(params)}${urlParams && `?${urlParams}`}`;
};

/**
 * Test is path currently active
 * @param  {String} path
 * @param  {Object} [params]
 * @return {Boolean}
 */
export const isActivePath = (path, params?) => {
  const pathname = location.getCurrentPathname();

  // I want to match params from path with params from URL
  if (params) {
    const paramsFromUrl = _.drop(
      pathToRegexp.pathToRegexp(path).exec(pathname),
    );

    if (_.isEmpty(paramsFromUrl)) {
      return false;
    }

    const isNotMatch = _(pathToRegexp.parse(path))
      .filter((param: any) => param.name)
      .some(({ name, optional }: any, i) => {
        if (optional && !params[name]) {
          return false;
        }

        return _.toString(params[name]) !== paramsFromUrl[i];
      });

    return !isNotMatch;
  }

  return pathToRegexp.pathToRegexp(path).test(pathname);
};

/**
 * Navigation by URL
 * @param  {String} href
 * @param {Function?} callback
 */
export const goToPage = (href, callback?) => page(href, callback);

/**
 * Navigation by PATH, see map inside config file
 * @param  {String}  path
 * @param  {object?} params
 * @param  {Object?} queryParams
 */
export const goToPath = (path: string, params?: {}, queryParams?: {}) => {
  return page(compilePath(path, params, queryParams));
};

export const defineRoute = (path, ...params) => page(path, ...params);

export const goBack = () => {
  global.history.back();
};
